const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://github.com/Dinesh-Deore1',
  title: 'DD.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Dinesh Deore',
  role: 'Programmer',
  description:
    'Passionate tech enthusiast and aspiring developer. Eager to learn, grow, and make a positive impact through code.',
  // resume: 'https://example.com',
  social: {
    linkedin: 'https://www.linkedin.com/in/dinesh-deore11/',
    github: 'https://github.com/Dinesh-Deore1',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'TO DO APP',
    description:
      'Designed and implemented features including adding, editing, listing, and deleting tasks, offering users full control over their todos.',
    stack: ['Java', 'Servlet', 'MySql','JSP'],
    sourceCode: 'https://github.com/Dinesh-Deore1/To-Do-app-in-Java',
    livePreview: 'https://github.com/Dinesh-Deore1/To-Do-app-in-Java',
  },
  {
    name: 'SORTING VISUALIZER',
    description:
      'Created interactive sorting visualizer demonstrating various sorting algorithms, enhancing understanding of sorting processes. Visualize step-by-step sorting, and compare efficiency of algorithms.',
    stack: ['Javascript', 'Bootstrap', 'HTML','CSS'],
    sourceCode: 'https://github.com/Dinesh-Deore1/Sorting_Visualizer',
    livePreview: 'https://github.com/Dinesh-Deore1/Sorting_Visualizer',
  },
  {
    name: 'JOB PORTAL USING JAVA',
    description:
      'The Online Job Search project is a comprehensive online job search platform that allows users to search for open jobs, create job postings, and manage job postings',
    stack: ['Java', 'Servlet', 'MySql','JSP'],
    sourceCode: 'https://github.com/Dinesh-Deore1/Online_Job_Portal_In_Java',
    livePreview: 'https://github.com/Dinesh-Deore1/Online_Job_Portal_In_Java',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'HTML',
  'CSS',
  'JavaScript',
  'Java',
  'Python',
  'Django',
  'C',
  'DSA',
  'Git',
  'GitHub',
  'MySql',
  'MongoDB',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'dineshdeore.rcpit@mail.com',
}

export { header, about, projects, skills, contact }
